var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaySuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.827,
    height: 23.829,
    viewBox: "0 0 23.827 23.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "patch-check-fill",
    transform: "translate(-0.01 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0.01 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M15,1.294a4.3,4.3,0,0,0-6.157,0l-.926.95L6.593,2.227A4.3,4.3,0,0,0,2.238,6.582l.015,1.326-.947.926a4.3,4.3,0,0,0,0,6.157l.949.926-.016,1.326A4.3,4.3,0,0,0,6.593,21.6l1.326-.015.926.947a4.3,4.3,0,0,0,6.157,0l.926-.949,1.326.016a4.3,4.3,0,0,0,4.355-4.355l-.015-1.326.947-.926a4.3,4.3,0,0,0,0-6.157l-.949-.926.016-1.326a4.3,4.3,0,0,0-4.355-4.355l-1.326.015L15,1.3Zm.427,8.912-4.468,4.468a.745.745,0,0,1-1.054,0L7.673,12.44a.746.746,0,0,1,1.054-1.054l1.707,1.708,3.941-3.942a.746.746,0,0,1,1.054,1.054Z",
    transform: "translate(-0.01 0.002)",
    fill: "#34c38f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaySuccess);
export default __webpack_public_path__ + "static/media/pay-success.eaf0a5e1884cfe553ec90af0959a0610.svg";
export { ForwardRef as ReactComponent };